import { Component, OnInit,Input,Output,EventEmitter,forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR,FormControl, FormGroup } from '@angular/forms';
import { ConfigBaseComponent} from '../../.././../models/config-base-component';

@Component({
  selector: 'app-config-controls-page',
  templateUrl: './config-controls-page.component.html',
  styleUrls: ['./config-controls-page.component.css']
})
export class ConfigControlsPageComponent extends ConfigBaseComponent implements OnInit {



}
